import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useController } from 'react-hook-form';
import Checkbox from '../checkbox';
import CheckboxGroup from '../checkbox-group';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';
import { OPTION_TYPE } from '../base-select/types';
import { TOOLTIP_PROP_TYPES } from '../tooltip/types';

const defaultRules = {};

const CheckboxGroupField = ({ name, options, control, rules = defaultRules, onChange = noop }) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (isChecked, value) => {
      const newValue = isChecked
        ? [...field.value, value]
        : field.value.filter((item) => item !== value);
      field.onChange(newValue);
      if (onChange) onChange(newValue, isChecked, value);
    },
    [field, onChange]
  );

  return (
    <CheckboxGroup>
      {options.map(({ label, value, ...otherProps }, index) => {
        const id = `${field.name}-${index}`;
        const checked = field.value.includes(value);

        return (
          <Checkbox
            {...otherProps}
            key={id}
            id={id}
            name={id}
            label={label}
            value={value}
            checked={checked}
            onChange={handleChange}
          />
        );
      })}
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </CheckboxGroup>
  );
};

CheckboxGroupField.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      ...OPTION_TYPE,
      description: PropTypes.node,
      disabled: PropTypes.bool,
      tooltipProps: PropTypes.shape(TOOLTIP_PROP_TYPES),
      isLabelBold: PropTypes.bool,
    })
  ).isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  onChange: PropTypes.func,
};

export default CheckboxGroupField;
